

// import iconVided from "../../../Icons/NV/tips/tips-video-icon.png";
import iconVided from "../../../Icons/NV/tips/play-vid-black.png";


class generateHtml {

    // <img class="maiHomeScreenTipsCon7" src="${data.images[0].res_500}">

    _generateTip(data, i) {
        console.log(data);
        return `
            <div data-index="${i}" class="maiHomeScreenTipsCon6">
                <div
                    class="maiHomeScreenTipsCon7"
                    style="background-image:url('${data.images[0].res_500}')"
                ></div> 
                <img class="maiHomeScreenTipsCon8" src="${iconVided}">
            </div>
        `
    }

}

export default new generateHtml()